module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I would like to thank Kevin T. Kelly, Ethan Schrage, Ann Schrage, Paul Tenkotte, Rick Pender, the staff of the Cincinnati/Hamilton County Public Library, Kenton County Public Library, the Price Hill Historical Society, the Cincinnati History Library and Archives at Cincinnati Museum Center and the Taft Museum of Art.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1789404b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 72
// module chunks = 0